export default __webpack_public_path__ + "static/media/fastT.fd395e3c.jpg";